/**
 * @module simulation.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const SimulationService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Basic CRUD operations
    createSimulation: builder.mutation({
      query: (simulationData) => ({
        url: AppConfig.getUrl('/simulations'),
        method: 'POST',
        body: simulationData,
      }),
    }),
    getSimulation: builder.mutation({
      query: (simulationNumber) => ({
        url: AppConfig.getUrl(`/simulations/${simulationNumber}`),
        method: 'GET',
      }),
    }),
    updateSimulation: builder.mutation({
      query: ({ simulationNumber, ...simulationData }) => ({
        url: AppConfig.getUrl(`/simulations/${simulationNumber}`),
        method: 'PATCH',
        body: simulationData,
      }),
    }),
    deleteSimulation: builder.mutation({
      query: (simulationNumber) => ({
        url: AppConfig.getUrl(`/simulations/${simulationNumber}`),
        method: 'DELETE',
      }),
    }),

    // Simulation-specific operations
    startSimulation: builder.mutation({
      query: (simulationNumber) => ({
        url: AppConfig.getUrl(`/simulations/${simulationNumber}/start`),
        method: 'POST',
      }),
    }),
    stopSimulation: builder.mutation({
      query: (simulationNumber) => ({
        url: AppConfig.getUrl(`/simulations/${simulationNumber}/stop`),
        method: 'POST',
      }),
    }),

    // Query operations
    getActiveSimulations: builder.mutation({
      query: (params = {}) => ({
        url: AppConfig.getUrl('/simulations/active'),
        method: 'GET',
        params,
      }),
    }),
    getArchivedSimulations: builder.mutation({
      query: (params = {}) => ({
        url: AppConfig.getUrl('/simulations/archived'),
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useCreateSimulationMutation,
  useGetSimulationMutation,
  useUpdateSimulationMutation,
  useDeleteSimulationMutation,
  useStartSimulationMutation,
  useStopSimulationMutation,
  useGetActiveSimulationsMutation,
  useGetArchivedSimulationsMutation,
} = SimulationService
